import type { LanguageIdentifiers, LanguageStoreState } from "./useLanguageStore";

export const SPANISH: LanguageStoreState = {
    label: "Spanish",
    language: "es-US",
    audioType: "PreRecordedDisclosuresSpanish",
    abbreviation: "Spa",
    locale: "es-mx",
};

export const ENGLISH: LanguageStoreState = {
    label: "English",
    language: "en-US",
    audioType: "PreRecordedDisclosures",
    abbreviation: "Eng",
    locale: "en-us",
};

export function getLanguageState(lang?: LanguageIdentifiers | null): LanguageStoreState {
    switch (lang) {
        case "Spanish":
        case "es-US":
        case "PreRecordedDisclosuresSpanish":
        case "Spa":
        case "es-mx":
            return SPANISH;
        case "English":
        case "en-US":
        case "PreRecordedDisclosures":
        case "Eng":
        case "en-us":
        default:
            return ENGLISH;
    }
}
